import {
  Box, Checkbox, FormControlLabel, FormGroup,
} from "@mui/material";
import EmailAddressTextField from "../../../components/EmailAddressField";
import {
  DateRequiredMessageByRequestType,
  defaultErrorsShippingInformation,
  defaultErrorsShippingInformationSiteToSite,
  defaultShippingAddress,
  defaultShippingItem,
  defaultShippingRequest,
  labelProp,
  WORK_REQUEST_TYPES_ENUM,
} from "./constants";
import { WorkRequestFormAutocomplete, WorkRequestFormDate, WorkRequestFormInput } from "./WorkRequestFormInput";
import BillingInfoField from "../../../components/BillingInfoField";
import { useEffect, useState } from "react";
import { DatePickerKeyDownEvent, formatCreatedAndModifiedDateInfo } from "../../../global";

const WorkRequestInformation = ({
  sites,
  sitesLoading,
  requestFacilities,
  requestFacilitiesLoading,
  requestTypes,
  requestTypesLoading,
  // businessUnits,
  // businessUnitsLoading,
  workRequestPriority,
  workRequestPriorityLoading,
  setMyWorkRequest,
  myWorkRequest,
  setErrors,
  errors,
  setNonChemicalShipping,
  requestStatus,
  requestStatusLoading,
  isProcess,
  disableForm,
  workRequestFetched,
  shippingRequest,
  setShippingRequest,
  setErrorsShipping,
  errorsShipping,
  mySamplesInfo,
  setMySamplesInfo,
  setShippingAddress,
  workRequestTypeSiteMappingList,
  availableLocations,
  currentUserEmail
}) => {
  const [assignedToEmailError, setAssignedToEmailError] = useState(null);
  const normalizeStatus = (status) => (status || "").trim().toLowerCase().replace(/[\s_-]/g, "");
  const normalizeIdentity = (value) => (value || "").trim().toLowerCase();

  const commonProps = {
    setData: setMyWorkRequest,
    data: myWorkRequest,
    setErrors,
    errors
  }

  const commonPropsShipping = {
    setData: (data) => {
      setShippingRequest(data);
    },
    data: shippingRequest,
    setErrors: setErrorsShipping,
    errors: errorsShipping
  };

  const isShipping = myWorkRequest.typeName === WORK_REQUEST_TYPES_ENUM.SHIPPING;
  const isSiteToSite = myWorkRequest.typeName === WORK_REQUEST_TYPES_ENUM.EXXON_MOBIL_SITE_TO_SITE_TRANSPORT;
  const showShipping = isShipping || isSiteToSite;
  const showStatus = isProcess || (workRequestFetched?.id > 0 && workRequestFetched?.statusName !== 'Draft');
  const isOwner =
    normalizeIdentity(currentUserEmail) === normalizeIdentity(myWorkRequest?.requestedByEmail) ||
    normalizeIdentity(currentUserEmail) === normalizeIdentity(myWorkRequest?.createdByEmail);
  const currentStatus = normalizeStatus(myWorkRequest?.statusName);
  const ownerAllowedStatuses =
    currentStatus === "submitted"
      ? ["OnHold", "Cancelled"]
      : currentStatus === "onhold"
      ? ["Submitted", "Cancelled"]
      : [];
  const submissionStatusOptions =
    !isProcess && isOwner && ownerAllowedStatuses.length > 0
      ? ownerAllowedStatuses.map((statusName) => {
          const existing = requestStatus.find(
            (status) => normalizeStatus(status.statusName) === normalizeStatus(statusName),
          );
          return existing ?? { statusName };
        })
: requestStatus.filter(
    (status) =>
      normalizeStatus(status.statusName) === currentStatus ||
      normalizeStatus(status.statusName) === "cancelled",
  );

  useEffect(() => {
    if (isProcess) {
      setErrors({
        ...errors,
        statusName: false
      })
    } else {
      delete errors.statusName;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function isDateMoreThanNDaysFromToday(selectedDate, days) {
    if (selectedDate) {
      const today = new Date();
      const targetDate = new Date(selectedDate);

      const futureDate = new Date();
      futureDate.setDate(today.getDate() + days);

      targetDate?.setHours(0, 0, 0, 0);
      futureDate.setHours(0, 0, 0, 0);

      return targetDate > futureDate;
    }
    return false;
  }

  const getGridColumnsFirstRow = () => {
    const baseColumns = ["1fr", "1.5fr", "1.5fr", "1fr"];
    const conditions = [showStatus, showShipping];

    const extraColumns = conditions.filter(Boolean).map(() => "1fr");

    return [...baseColumns, ...extraColumns].join(" ");
  }

  const filteredSites = sites.filter(site =>
    site.siteName !== shippingRequest.siteSelection &&
    workRequestTypeSiteMappingList.some(mapping =>
      mapping.siteName === site.siteName &&
      mapping.workRequestTypeName === myWorkRequest.typeName
    ) &&
    requestFacilities.some(facility => facility.siteName === site.siteName)
  );

  // const mustAssignPersonToWorkRequest = isProcess && myWorkRequest?.statusName ===  "Completed";

  const isGlobalSiteLocation = (locationName) => {
    if (!locationName) return false;
    const location = availableLocations.find(loc => loc.locationName === locationName);
    return location?.siteName === "Global Usage - No Site";
  }

  return (
    <div>
      <Box style={{ width: "100%" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: getGridColumnsFirstRow(),
            gap: "1rem",
            height: 60
          }}
        >
          <WorkRequestFormAutocomplete
            {...commonProps}
            options={requestTypes}
            property={'typeName'}
            noOptionsText={
              requestTypesLoading
                ? "Loading Types..."
                : "No Types Found"
            }
            label={labelProp['typeName']}
            required
            disabled={disableForm ||
              (workRequestFetched &&
                ((workRequestFetched.statusName !== 'Draft') ||
                  (workRequestFetched.parentWorkRequestID && workRequestFetched.typeName === WORK_REQUEST_TYPES_ENUM.SHIPPING)
                )
              )
            }
            setData={(data) => {
              const shipping = data.typeName === WORK_REQUEST_TYPES_ENUM.SHIPPING || data.typeName === WORK_REQUEST_TYPES_ENUM.EXXON_MOBIL_SITE_TO_SITE_TRANSPORT;

              commonProps.setData({
                ...data,
                siteName: null,
                facilityName: null,
                testSubmissionJSON: null,
              });
              if (data.typeName === WORK_REQUEST_TYPES_ENUM.EXXON_MOBIL_SITE_TO_SITE_TRANSPORT) {
                setErrorsShipping(defaultErrorsShippingInformationSiteToSite);
              } else {
                setErrorsShipping(defaultErrorsShippingInformation);
              }
              if (shipping) {
                setErrors({
                  ...errors,
                  typeName: data.typeName && data.typeName !== '' ? false : null,
                  siteName: null,
                  facilityName: null,
                  // chargeCode: data.chargeCode && data.chargeCode !== '' ? false : null
                })
              } else {
                // delete errors.chargeCode;
                setErrors({
                  ...errors,
                  typeName: data.typeName && data.typeName !== '' ? false : null,
                  siteName: null,
                  facilityName: null,
                })
              }
              setShippingRequest(defaultShippingRequest);
              setShippingAddress(defaultShippingAddress);
              setMySamplesInfo([]);
            }}
          />
          <WorkRequestFormAutocomplete
            {...commonProps}
            options={filteredSites}
            property={'siteName'}
            noOptionsText={
              sitesLoading
                ? "Loading Sites..."
                : "No Sites Found"
            }
            label={labelProp['siteName']}
            disabled={disableForm}
            data={{ ...myWorkRequest, siteName: myWorkRequest.siteName ?? null }}
            setData={(data) => {
              setMyWorkRequest({
                ...data,
                facilityName: null
              })

              setMySamplesInfo([...mySamplesInfo.map(sample => ({
                ...sample,
                requestedLocationName: !isGlobalSiteLocation(sample?.requestedLocationName) ? null : sample?.requestedLocationName
              }))]);
            }}
            required
          />
          <WorkRequestFormAutocomplete
            {...commonProps}
            options={requestFacilities.filter(f => 
              (f.siteName === myWorkRequest.siteName || f.facilityName === myWorkRequest.facilityName) &&
              f.workRequestTypes?.some(wrt => wrt.workRequestTypeName === myWorkRequest.typeName)
            )}
            property={'facilityName'}
            noOptionsText={
              requestFacilitiesLoading
                ? "Loading Facilities..."
                : "No Facilities Found"
            }
            label={labelProp['facilityName']}
            disabled={disableForm || !myWorkRequest.siteName || myWorkRequest.siteName === ''}
            required
          />

          {/* <WorkRequestFormAutocomplete
            {...commonProps}
            options={businessUnits}
            property={'businessUnitName'}
            noOptionsText={
              businessUnitsLoading
                ? "Loading Business Units..."
                : "No Business Units Found"
            }
            label={labelProp['businessUnitName']}
            required
            disabled={disableForm}
          /> */}

          {showStatus && <WorkRequestFormAutocomplete
            {...commonProps}
            options={
              isProcess
                ? requestStatus
                : submissionStatusOptions
            }
            property={'statusName'}
            noOptionsText={
              requestStatusLoading
                ? "Loading Status..."
                : "No Status Found"
            }
            label={labelProp['statusName']}
            required={'statusName' in errors}
            disabled={disableForm}
            setData={(data) => {
              // if (isProcess && data?.statusName === 'Completed') {
              //   setErrors({
              //     ...errors,
              //     assignedToEmail: data.assignedToEmail && data.assignedToEmail !== '' ? false : null
              //   })
              // } else {
                delete errors.assignedToEmail;
                setErrors({
                  ...errors,
                })
                if (data?.statusName === 'Submitted' && myWorkRequest.statusName === 'Assigned') {
                  data.assignedToEmail = null;
                }
              // }
              commonProps.setData(data);
            }}
          />}

          <WorkRequestFormDate
            {...commonProps}
            property={'requestedCompletionDate'}
            label={labelProp['requestedCompletionDate']}
            minDate={new Date()}
            maxDate={
              myWorkRequest.lastAcceptableCompletionDate
                ? new Date(myWorkRequest.lastAcceptableCompletionDate)
                : null
            }
            required
            disabled={disableForm}
            setData={(data) => {
              if (!isDateMoreThanNDaysFromToday(data.requestedCompletionDate, 3)) {
                data.priorityName = "Rush";

                setErrors({
                  ...errors,
                  priorityReason: data.priorityReason && data.priorityReason !== '' ? false : null
                })
              } else {
                data.priorityName = "Normal";
                delete errors.priorityReason;
              }

              setMyWorkRequest(data)
            }}
            tooltipMessage={DateRequiredMessageByRequestType[myWorkRequest.typeName]}
          />
          {showShipping && <WorkRequestFormDate
            {...commonPropsShipping}
            property={'requestedDeliveryDate'}
            label={labelProp['requestedDeliveryDate']}
            minDate={
              new Date(new Date(myWorkRequest.requestedCompletionDate).getTime() + 24 * 60 * 60 * 1000)
            }
            required
            onKeyDown={DatePickerKeyDownEvent}
            disabled={disableForm || !myWorkRequest.requestedCompletionDate}
          />}
          {/* <WorkRequestFormDate
            {...commonProps}
            property={'lastAcceptableCompletionDate'}
            label={labelProp['lastAcceptableCompletionDate']}
            minDate={
              new Date(myWorkRequest.requestedCompletionDate || new Date())
            }
            required
            disabled={disableForm}
          /> */}
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: isProcess ? "2fr 2fr 1fr 3fr" : "3fr 1fr 4fr",
            gap: "1rem",
            height: 60,
          }}
        >
          {isProcess && <EmailAddressTextField
            style={{marginBottom: 11}}
            fontSize={16}
            margin={"none"}
            validatedUserEmail={
              myWorkRequest.assignedToEmail === null
                ? ""
                : myWorkRequest.assignedToEmail
            }
            setValidatedUserEmail={(value) => {
              setMyWorkRequest(() => ({
                ...myWorkRequest,
                assignedToEmail: value,
              }));
            }}
            setHasErrors={(error) => {
              // setErrors((prev) => ({
              //   ...prev,
              //   assignedToEmail: error,
              // }));
              setAssignedToEmailError(error);
            }}
            // hasErrors={ mustAssignPersonToWorkRequest ?
            //   errors.assignedToEmail === null
            //     ? false
            //     : errors.assignedToEmail : false
            // }
            hasErrors={ assignedToEmailError }
            isDisabled={disableForm}
            labelText={labelProp['assignedToEmail']}
            placeholderText={labelProp['assignedToEmail']}
            showPlusMeButton={true}
          />}
          <BillingInfoField
            billingValue={
              myWorkRequest.chargeCode === null ? "" : myWorkRequest.chargeCode
            }
            handleChange={(e) => {
              commonProps.setData(() => ({
                ...commonProps.data,
                chargeCode: e,
              }));
              setErrors((prev) => ({
                ...prev,
                chargeCode: !e || e === "" ? true : false,
              }));
            }}
            margin="normal"
            fieldWidth="100%"
            marginLeft={null}
            marginRight={null}
            isDisabled={disableForm}
            hasErrors={ errors.chargeCode === null ? false : errors.chargeCode}
            required={true}
            
          />
          <WorkRequestFormAutocomplete
            {...commonProps}
            setData={(data) => {
              if (data?.priorityName === 'Rush') {
                setErrors({
                  ...errors,
                  priorityReason: null
                })
              } else {
                delete errors.priorityReason;
              }
              commonProps.setData(data);
            }}
            options={workRequestPriority}
            property={'priorityName'}
            noOptionsText={
              workRequestPriorityLoading
                ? "Loading Priorities..."
                : "No Priorities Found"
            }
            label='Priority'
            disabled={disableForm || !isDateMoreThanNDaysFromToday(myWorkRequest.requestedCompletionDate, 3)}
          />

          <WorkRequestFormInput
            {...commonProps}
            label={labelProp['priorityReason']}
            property="priorityReason"
            required={'priorityReason' in errors}
            disabled={disableForm}
          />
        </div>

        <div style={{ display: "flex", gap: "10px", alignItems: "baseline" }}>
          <WorkRequestFormInput
            {...commonProps}
            label={labelProp['description']}
            property="description"
            required
            disabled={disableForm}
          />

          <EmailAddressTextField
            fontSize={16}
            margin={"none"}
            fieldWidth={"30%"}
            validatedUserEmail={
              myWorkRequest.requestedByEmail === null
                ? ""
                : myWorkRequest.requestedByEmail
            }
            setValidatedUserEmail={(value) => {
              setMyWorkRequest(() => ({
                ...myWorkRequest,
                requestedByEmail: value,
              }));
            }}
            setHasErrors={(error) => {
              setErrors((prev) => ({
                ...prev,
                requestedByEmail: error,
              }));
            }}
            hasErrors={
              errors.requestedByEmail === null
                ? false
                : errors.requestedByEmail
            }
            isDisabled={disableForm}
            labelText={`* ${labelProp['requestedByEmail']}`}
            placeholderText="* Requester Email"
            showPlusMeButton={true}
          />
        </div>
      </Box>
      {showShipping && <FormGroup>
        <FormControlLabel
          control={<Checkbox />}
          checked={myWorkRequest.isNonChemical}
          onChange={(e) => {
            setMyWorkRequest(() => ({
              ...myWorkRequest,
              isNonChemical: e.target.checked,
            }));
            setNonChemicalShipping([defaultShippingItem]);
          }}
          label={<>Is non-chemical request?</>}
          disabled={disableForm}
        />
      </FormGroup>}
      {isProcess && <div style={{ marginBottom: 35 }}>
        {formatCreatedAndModifiedDateInfo(myWorkRequest.createdDate, myWorkRequest.createdByEmail, myWorkRequest.lastModifiedDate, myWorkRequest.lastModifiedByEmail, 'Submitted By')}
      </div>}
    </div>
  );
};

export default WorkRequestInformation;
